if (!customElements.get('tazty-marquee')) {
  class TaztyMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.source = this.querySelector('[data-marquee-source]');

      if (!this.track || !this.source) return;

      this.sync = this.sync.bind(this);
      this.resizeObserver = new ResizeObserver(this.sync);
      this.resizeObserver.observe(this);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.sync);
      } else {
        requestAnimationFrame(this.sync);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    sync() {
      if (!this.track || !this.source) return;

      Array.from(this.track.children).forEach((group) => {
        if (group !== this.source) group.remove();
      });

      const sourceWidth = this.source.getBoundingClientRect().width;
      if (!sourceWidth) return;

      if (this.classList.contains('announcement-bar--static')) {
        this.style.setProperty('--marquee-start', '0px');
        this.style.setProperty('--marquee-end', '0px');
        this.setAttribute('data-marquee-ready', '');
        return;
      }

      const cloneGroup = () => {
        const clone = this.source.cloneNode(true);
        clone.removeAttribute('data-marquee-source');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((item) => {
          item.removeAttribute('data-shopify-editor-block');
        });
        return clone;
      };

      let startOffset = 0;
      let endOffset = -sourceWidth;
      const viewport = this.querySelector('.announcement-bar__inner') || this;
      const viewportWidth = viewport.clientWidth;

      if (this.hasAttribute('data-marquee-center-start')) {
        this.track.insertBefore(cloneGroup(), this.source);
        const firstVisibleItem = Array.from(this.source.children).find((item) => getComputedStyle(item).display !== 'none');
        const firstItemWidth = firstVisibleItem ? firstVisibleItem.getBoundingClientRect().width : sourceWidth;
        startOffset = ((viewportWidth - firstItemWidth) / 2) - sourceWidth;
        endOffset = this.getAttribute('data-marquee-direction') === 'right'
          ? startOffset + sourceWidth
          : startOffset - sourceWidth;
      }

      const requiredWidth = viewportWidth + Math.abs(Math.min(startOffset, endOffset, 0));
      do {
        this.track.appendChild(cloneGroup());
      } while (this.track.scrollWidth < requiredWidth);

      this.style.setProperty('--marquee-distance', `${sourceWidth}px`);
      this.style.setProperty('--marquee-offset', `-${sourceWidth}px`);
      this.style.setProperty('--marquee-start', `${startOffset}px`);
      this.style.setProperty('--marquee-end', `${endOffset}px`);
      this.setAttribute('data-marquee-ready', '');
    }
  }

  customElements.define('tazty-marquee', TaztyMarquee);
}
